import StorefrontIcon from "@mui/icons-material/Storefront";
import BookIcon from "@mui/icons-material/Book";
import CategoryIcon from "@mui/icons-material/Category";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CommentIcon from "@mui/icons-material/Comment";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import WorkIcon from "@mui/icons-material/Work";
import PeopleIcon from "@mui/icons-material/People";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GradingIcon from "@mui/icons-material/Grading";
import ImageIcon from "@mui/icons-material/Image";
import YouTubeIcon from "@mui/icons-material/YouTube";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import LinkIcon from "@mui/icons-material/Link";
import HttpsIcon from "@mui/icons-material/Https";
import { HiOutlineClipboardList } from "react-icons/hi";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PaymentsIcon from "@mui/icons-material/Payments";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { FcGoogle } from "react-icons/fc";
import { MdEvent, MdSupportAgent } from "react-icons/md";
import {
  DashboardCustomizeSharp,
  Image,
  ImagesearchRoller,
  SupportAgentRounded,
} from "@mui/icons-material";
import UnMatchedSearch from "../Components/ChatAgent/UnmatchedSearch";

export const LeftMenu = [
  {
    id: 1,
    navItem: "Store Hub",
    navIcon: <StorefrontIcon className=" text-2xl" />,
    navLink: "/storeHub",
    AccessLevel: ["SuperAdmin"],
    children: [],
  },

  {
    id: "1-a",
    navItem: "Images",
    navIcon: <ImagesearchRoller className=" text-2xl" />,
    navLink: "/all-images",
    AccessLevel: ["SuperAdmin"],
    children: [],
  },
  {
    id: 2,
    navItem: "Content",
    navIcon: <BookIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      {
        navItem: "Page",
        navLink: "/page",
        navIcon: <SettingsApplicationsIcon />,
      },
      { navItem: "Blog", navLink: "/blog", navIcon: <BookIcon /> },
      { navItem: "Category", navLink: "/category", navIcon: <CategoryIcon /> },
      {
        navItem: "Sub Category",
        navLink: "/sub-category",
        navIcon: <CategoryIcon />,
      },

      {
        navItem: "Event",
        navLink: "/event",
        navIcon: <MdEvent />,
      },
      { navItem: "News", navLink: "/news", navIcon: <NewspaperIcon /> },
      { navItem: "Comments", navLink: "/comments", navIcon: <CommentIcon /> },
      {
        navItem: "CMS",
        navLink: "/cms2",
        navIcon: <SettingsApplicationsIcon />,
      },

      {
        navItem: "FAQ",
        navLink: "/faq-pages",
        navIcon: <QuestionAnswerIcon />,
      },

      {
        navItem: "Customizetions",
        navLink: "/customizetion",
        navIcon: <DashboardCustomizeSharp />,
      },
    ],
  },

  {
    id: "2-1-A",
    navItem: "Menu",
    navIcon: <BookIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      { navItem: "Menu", navLink: "/menu", navIcon: <BookIcon /> },
      { navItem: "Sub Menu", navLink: "/sub-menu", navIcon: <BookIcon /> },
      {
        navItem: "Sub Sub Menu",
        navLink: "/sub-sub-menu",
        navIcon: <CategoryIcon />,
      },
    ],
  },

  {
    id: "2-1",
    navItem: "Policy Privacy",
    navIcon: <BookIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      {
        navItem: "Policy Privacy",
        navLink: "/policy-privacy",
        navIcon: <BookIcon />,
      },
      {
        navItem: "Return and Refund Policy",
        navLink: "/return-and-refund-policy",
        navIcon: <CategoryIcon />,
      },
    ],
  },

  {
    id: 3,
    navItem: "Company",
    navIcon: <WorkIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      { navItem: "Careers", navLink: "/career", navIcon: <WorkIcon /> },
      { navItem: "Clients", navLink: "/clients", navIcon: <PeopleIcon /> },
      { navItem: "Partners", navLink: "/partners", navIcon: <HandshakeIcon /> },
      {
        navItem: "Testimonials",
        navLink: "/testimonials",
        navIcon: <GradingIcon />,
      },
    ],
  },
  {
    id: 4,
    navItem: "Media",
    navIcon: <ImageIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      { navItem: "Gallery", navLink: "/gallery", navIcon: <ImageIcon /> },
      {
        navItem: "Gallery Image",
        navLink: "/gallery-image",
        navIcon: <ImageIcon />,
      },
      {
        navItem: "YouTube Folder",
        navLink: "/youtube-folder",
        navIcon: <YouTubeIcon />,
      },
      { navItem: "Slider", navLink: "/slider", navIcon: <SlideshowIcon /> },

      { navItem: "Images", navLink: "/images", navIcon: <Image /> },
    ],
  },
  {
    id: 5,
    navItem: "Projects",
    navIcon: <WorkIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      { navItem: "Project", navLink: "/project", navIcon: <WorkIcon /> },
      {
        navItem: "Case Study",
        navLink: "/case-study",
        navIcon: <WorkIcon />,
      },
      {
        navItem: "Project Category",
        navLink: "/project_category",
        navIcon: <CategoryIcon />,
      },
      // {
      //   navItem: "Case Study",
      //   navLink: "/case-study",
      //   navIcon: <WorkIcon />,
      // },
    ],
  },
  {
    id: 6,
    navItem: "Marketing",
    navIcon: <LinkIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      { navItem: "Meta", navLink: "/meta", navIcon: <LinkIcon /> },
      {
        navItem: "Google",
        navLink: "/adsence",
        navIcon: <FcGoogle className="text-xl" />,
      },
      {
        navItem: "Facebook Pixel",
        navLink: "/facebookpixal",
        navIcon: <HttpsIcon />,
      },
    ],
  },

  //update new
  {
    id: 10,
    navItem: "Page Design Setup",
    navIcon: <DashboardCustomizeSharp />,
    AccessLevel: ["StoreAdmin"],
    children: [
      {
        navItem: "Page",
        navLink: "/page-design-setup",
        navIcon: <DashboardCustomizeSharp />,
      },
    ],
  },
  // DIRECT / TOP-LEVEL
  {
    id: 11,
    navItem: "Document",
    navIcon: <MenuBookIcon className="text-xl" />,
    navLink: "/document",
    AccessLevel: ["StoreAdmin"],
    children: [],
  },

  {
    id: 7,
    navItem: "User Panel",
    navIcon: <HiOutlineClipboardList className=" text-xl" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      {
        navItem: "Manage Users",
        navLink: "/user-database",
        navIcon: <HiOutlineClipboardList />,
      },
      {
        navItem: "KYC Status",
        navLink: "/kyc-status",
        navIcon: <VerifiedUserIcon />,
      },
      {
        navItem: "Transaction Feed",
        navLink: "/transaction-feed",
        navIcon: <PaymentsIcon />,
      },
    ],
  },
  {
    id: 8,
    navItem: "Support",
    navIcon: <ContactEmergencyIcon className="" />,
    AccessLevel: ["StoreAdmin"],
    children: [
      {
        navItem: "Contact Us",
        navLink: "/contact-us",
        navIcon: <ContactEmergencyIcon />,
      },
      { navItem: "Book", navLink: "/book", navIcon: <MenuBookIcon /> },
    ],
  },

  {
    id: 9,
    navItem: "Chat Agent",
    navIcon: <ContactEmergencyIcon className="" />,
    AccessLevel: ["StoreAdmin", "Chat Agent"],
    children: [
      {
        navItem: "Chat Agent",
        navLink: "/chat-agent",
        navIcon: <SupportAgentRounded />,
      },
      {
        navItem: "Chat Agent Q.A.",
        navLink: "/chat-agent/question-answer",
        navIcon: <MdSupportAgent />,
      },
      {
        navItem: "Chat Bot Messages",
        navLink: "/chat-agent/chatbot-messages",
        navIcon: <MdSupportAgent />,
      },
      {
        navItem: "UnMatched Search",
        navLink: "/chat-agent/unmatched-search",
        navIcon: <MdSupportAgent />,
      },

      {
        navItem: "Waiting User",
        navLink: "/waiting-chatuser",
        navIcon: <MdSupportAgent />,
      },
    ],
  },
];
